export default __webpack_public_path__ + "static/cmf-logo-746ac637407442d3734153c8a5bb4165.png";